import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-center, resize big, box, arrow"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowCenter"><path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3V14H20V4L4 4L4 20H14V21H3L3 3ZM9 9H16V10H10.7071L18.7071 18L18 18.7071L10 10.7071V16H9V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowCenter;
